// extracted by mini-css-extract-plugin
module.exports = {"companyLogo__wrapper":"CompanyLogo_companyLogo__wrapper__2Rq61"};